import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}>
      <g data-name="Designed by Freepik">
        <g data-name="Group 1599">
          <path
            data-name="Polygon 3"
            d="M18.31 12a7.72 7.72 0 0113.38 0l11.38 19.88a7.7 7.7 0 01-6.69 11.52H13.62a7.71 7.71 0 01-6.69-11.53z"
            fill="#00df76"
          />
          <text
            transform="translate(14.24 38.78)"
            style={{
              isolation: 'isolate'
            }}
            fontSize={35.44}
            fill="#fff"
            fontFamily="Rubik-Bold,Rubik"
            fontWeight={700}>
            {'+'}
          </text>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
